import React, {PropTypes} from 'react'
import {Modal} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import HorseReportForm from '../HorseReport/HorseReportForm'
import './HorseReportPhoto.css'

class HorseReportPhoto extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null,
      report: {
        photo_id: this.props.id,
        context: ''
      }
    }
  }

  componentWillMount () {
    if (this.props.reportPhotoTypes.length === 0) {
      Actions.loadHorseReportPhotoTypes()
    }
  }

  render () {
    const {error, report} = this.state
    const {toggler, isVisible, reportPhotoTypes} = this.props
    const hider = () => {
      toggler(false)
    }
    return (
      <Modal show={isVisible} onHide={hider} bsSize="sm" aria-labelledby="contained-modal-title-sm">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-sm">گزارش اشکال در تصویر</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <HorseReportForm
            reportTypes={reportPhotoTypes}
            values={report}
            placeholder="نوع گزارش"
            onSubmit={(values) => {
              Actions.horseReportPhoto(values).then((res) => {
                // TODO: show Thank You message
                hider()
              })
            }}
          />
        </Modal.Body>
      </Modal>
    )
  }
}

HorseReportPhoto.propTypes = {
  toggler: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired
}

const mapStateToProps = (state) => {
  return {
    reportPhotoTypes: state.horse.reportPhotoTypes
  }
}

export default connect(mapStateToProps)(HorseReportPhoto)



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseReportPhoto/HorseReportPhoto.js